import React, { Suspense } from 'react';
import Onboarding from "../onboarding/";
function Root() {
  return (
    <>
      <Suspense fallback={<div></div>}>
        <Onboarding />
      </Suspense>
    </>
  );
}

export default Root;
